import { useTranslations } from "../../i18n";

export function WidgetShell({ children }: { children: React.ReactNode }) {
  return (
    <div className="w-full">
      {children}
      <PoweredBy />
    </div>
  );
}

/** « Réservation par BookZen », discret, sous chaque widget. */
function PoweredBy() {
  const t = useTranslations("common");

  return (
    <footer className="flex items-center justify-center gap-1.5 pt-3 pb-1 text-[11px] text-ashe">
      {t("poweredBy")}
      <a
        href="https://bookzen.ch"
        target="_blank"
        rel="noopener"
        className="inline-flex items-center gap-1 font-semibold text-ink-soft no-underline hover:text-ink"
      >
        <svg width="16" height="16" viewBox="0 0 100 100" fill="none" aria-hidden="true">
          <path
            d="M85.7 37A38 38 0 1 1 56.6 12.6"
            stroke="#3f6b5a"
            strokeWidth="9"
            strokeLinecap="round"
          />
          <path
            d="M31 50L45 63.5L83 19"
            stroke="#c96f4a"
            strokeWidth="9"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
        BookZen
      </a>
    </footer>
  );
}
